import React from "react";
import "./TelegramMiniMultiConfirmationForm.css";
import TelegramText from "../Text/TelegramText";
import { useSelector } from "react-redux";

const TelegramMiniMultiConfirmationForm = (props) => {
  const userProfile = useSelector((state) => state.userProfile);
  const selectedTimeSlot = useSelector((state) => state.selectedTimeSlot);
  const checkoutComment = useSelector((state) => state.checkoutComment);


  return (
    <div
      {...props}
      className={
        "TelegramMiniMultiConfirmationForm TelegramMiniMultiConfirmationForm--compact " +
        props.className
      }
    >
      {/* Ultra-compact row: Name, Phone, Postal (33% each) */}
      <div className="form-row form-row--triple">
        <div className="form-field-third">
          <TelegramText
            className={"telegramSubtitle telegramSubtitle--compact"}
          >
            {props.fieldlabel_name}
          </TelegramText>
          <TelegramText className={"telegramText telegramText--compact"}>
            {userProfile.contactname}
          </TelegramText>
        </div>
        <div className="form-field-third">
          <TelegramText
            className={"telegramSubtitle telegramSubtitle--compact"}
          >
            {props.fieldlabel_phone}
          </TelegramText>
          <TelegramText className={"telegramText telegramText--compact"}>
            {userProfile.contactphone}
          </TelegramText>
        </div>
        <div className="form-field-third">
          <TelegramText
            className={"telegramSubtitle telegramSubtitle--compact"}
          >
            {props.fieldlabel_address}
          </TelegramText>
          <TelegramText className={"telegramText telegramText--compact"}>
            {userProfile.postalcode}
          </TelegramText>
        </div>
      </div>

      {/* Compact timeslot row */}
      <div className="form-row">
        <div className="form-field-full">
          <TelegramText
            className={"telegramSubtitle telegramSubtitle--compact"}
          >
            {props.fieldlabel_timeslot}
          </TelegramText>
          <div className="timeslot-card timeslot-card--readonly timeslot-card--ultra-compact">
            <span className="timeslot-inline">
              <span className="date">
                {selectedTimeSlot.date || selectedTimeSlot.text?.split(" - ")[0]}
              </span>
              <span className="time">
                {selectedTimeSlot.timeRange || selectedTimeSlot.text?.split(" - ").slice(1).join(" - ")}
              </span>
            </span>
          </div>
        </div>
      </div>

      {/* Comments section - only show when not empty, inline style */}
      {checkoutComment && checkoutComment.trim() !== "" && (
        <div className="form-row">
          <div className="form-field-full">
            <TelegramText
              className={"telegramSubtitle telegramSubtitle--compact"}
            >
              {props.fieldlabel_comments}:
            </TelegramText>
            <TelegramText
              className={
                "telegramText telegramText--compact telegramText--inline"
              }
            >
              {checkoutComment}
            </TelegramText>
          </div>
        </div>
      )}
    </div>
  );
};

export default TelegramMiniMultiConfirmationForm;
